import React, { Component } from 'react';
import { Button } from 'primereact/button';
import { ImplementationFor } from '../../shared/utility';

// ─── Helpers ──────────────────────────────────────────────────────────────────

let _uid = 1;
const makeRow = (fields) => {
    const row = { _id: _uid++ };
    fields.forEach(f => { row[f.fieldName] = null; });
    return row;
};

// ─── Single Cell ──────────────────────────────────────────────────────────────
// Mirrors exactly how your existing Inputs component renders a field.
// metaData is passed as-is from Redux — the individual component (SelectBox etc.)
// looks up its own options via metaData[fieldDescription] internally.

class DynamicCell extends Component {
    render() {
        const { field, row, metaData, onCellChange, ...rest } = this.props;
        const Component = ImplementationFor[parseInt(field.fieldType)];
        if (!Component) return null;

        return (
            // <Component
            //     {...field}
            //     {...rest}
            //     name={field.fieldName}
            //     label=""
            //     placeholder={field.fieldDescription}
            //     value={row[field.fieldName]}
            //     onInputChange={(name, value) => onCellChange(row._id, name, value)}
            //     metaData={metaData}
            // />

            <Component
    {...field}
    name={field.fieldName}
    label={field.fieldDescription}
    placeholder={field.fieldDescription}
    value={row[field.fieldName]}
    metaData={metaData}
    onInputChange={(e) => {
        const fieldName =
            e.target?.name ||
            field.fieldName;

        const value =
            e.value !== undefined
                ? e.value
                : e.target?.value;

        onCellChange(
            row._id,
            fieldName,
            value
        );
    }}
/>
        );
    }
}

// ─── DynamicDataTable ─────────────────────────────────────────────────────────
//
// Props:
//   fields        — array from API:
//                   [{ fieldName, fieldDescription, fieldType, required, ...rest }]
//   metaData      — passed straight from Redux mapStateToProps (same shape as
//                   your existing pages — key = fieldDescription, value = options[])
//   rows          — (optional) lifted rows; if omitted the table is self-managed
//   onRowsChange  — (optional) called with updated rows array (lifted state)
//   addLabel      — Add button label (default: "Add New Row")
//   title         — optional section heading
//   ...rest       — anything else (match, history, Redux props, etc.)
//                   forwarded to every cell component as-is

class DynamicDataTable extends Component {
    constructor(props) {
        super(props);
        this.selfManaged = !props.rows;
        this.state = this.selfManaged
            ? { rows: [makeRow(props.fields || [])] }
            : {};
    }

    get rows() {
        return this.selfManaged ? this.state.rows : this.props.rows;
    }

    setRows = rows => {
        if (this.selfManaged) this.setState({ rows });
        else this.props.onRowsChange && this.props.onRowsChange(rows);
    };

    handleCellChange = (rowId, fieldName, value) => {
        this.setRows(
            this.rows.map(r => r._id === rowId ? { ...r, [fieldName]: value } : r)
        );
    };

    handleAddRow    = ()    => this.setRows([...this.rows, makeRow(this.props.fields || [])]);
    handleDeleteRow = rowId => this.setRows(this.rows.filter(r => r._id !== rowId));

    render() {
        const {
            fields    = [],
            metaData  = {},
            addLabel  = 'Add New Row',
            title,
            // strip own props so they don't leak into cellPassthrough
            rows:          _rows,
            onRowsChange:  _onRowsChange,
            ...cellPassthrough          // match, history, dispatch, Redux props etc.
        } = this.props;
 
        const rows = this.rows;
        // console.log('Rendering DynamicDataTable with rows:', this.props);
        // console.log('Rendering DynamicDataTable with rows:', rows);

        return (
            <div style={{ border: '1px solid #dee2e6', borderRadius: '4px', overflow: 'hidden' }}>

                {/* Optional title */}
                {title && (
                    <div className="p-grid" style={{ margin: 0, padding: '8px 12px', background: '#f8f9fa', borderBottom: '1px solid #dee2e6' }}>
                        <div className="p-col-12">
                            <strong style={{ fontSize: '13px', color: '#333' }}>{title}</strong>
                        </div>
                    </div>
                )}

                {/* Column headers — one per field */}
                <div className="p-grid" style={{ margin: 0, padding: '6px 0', background: '#f8f9fa', borderBottom: '1px solid #dee2e6' }}>
                    {fields.map(field => (
                        <div key={field.fieldName} className="p-col">
                            <label style={{
                                fontSize: '11px', fontWeight: 700, color: '#888',
                                textTransform: 'uppercase', letterSpacing: '0.5px', margin: 0,
                            }}>
                                {field.fieldDescription}
                                {field.required && <span className="requiredColor"> *</span>}
                            </label>
                        </div>
                    ))}
                    <div style={{ width: '48px', flexShrink: 0 }} />
                </div>

                {/* Data rows */}
                {rows.map(row => (
                    <div
                        key={row._id}
                        className="p-grid align-items-center"
                        style={{margin: 0, borderBottom: '1px solid #f2f2f2' }}
                    >
                        {fields.map(field => (
                            <div key={field.fieldName} className="p-col" >
                                <DynamicCell
                                    field={field}
                                    row={row}
                                    metaData={metaData}
                                    onCellChange={this.handleCellChange}
                                    {...cellPassthrough}
                                />
                            </div>                 
                        ))}

                        <div className="p-col-fixed" style={{ width: '50px', display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
    

                            <Button
                                icon="pi pi-trash"
                                className="p-button-danger p-button-text p-button-sm"
                                // disabled={rows.length === 1}
                                onClick={() => this.handleDeleteRow(row._id)}
                                tooltip="Remove row"
                                tooltipOptions={{ position: 'top' }}
                            />
                        </div>
                    </div>
                ))}

                {/* Empty state */}
                {rows.length === 0 && (
                    <div className="p-grid" style={{ margin: 0 }}>
                        <div className="p-col-12" style={{ textAlign: 'center', padding: '24px', color: '#bbb', fontSize: '13px' }}>
                            No rows added yet.
                        </div>
                    </div>
                )}

                {/* Add row */}
                <div className="p-grid" style={{ margin: 0, padding: '8px 0' }}>
                    <div className="p-col-12" style={{ textAlign: 'right' }}>
                        <Button
                            label={addLabel}
                            icon="pi pi-plus"
                            className="p-button-outlined p-button-sm"
                            onClick={this.handleAddRow}
                            style={{ color: '#c0392b', borderColor: '#c0392b', fontSize: '12px' }}
                        />
                    </div>
                </div>

            </div>
        );
    }
}

export default DynamicDataTable;




// --------------------DynamicDatatable with Accordion---------------------------------


// import React, { Component } from 'react';
// import { Button } from 'primereact/button';
// import { Accordion, AccordionTab } from 'primereact/accordion';
// import { ImplementationFor } from '../../shared/utility';

// let _uid = 1;
// const makeRow = (fields) => {
//     const row = { _id: _uid++ };
//     fields.forEach(f => { row[f.fieldName] = null; });
//     return row;
// };

// const ACCORDION_THRESHOLD = 3;

// // ─── Single Cell ──────────────────────────────────────────────────────────────

// class DynamicCell extends Component {
//     render() {
//         const { field, row, metaData, onCellChange, ...rest } = this.props;
//         const Component = ImplementationFor[parseInt(field.fieldType)];
//         if (!Component) return null;

//         return (
//             <Component
//                 {...field}
//                 name={field.fieldName}
//                 label={field.fieldDescription}
//                 placeholder={field.fieldDescription}
//                 value={row[field.fieldName]}
//                 metaData={metaData}
//                 onInputChange={(e) => {
//                     const fieldName = e.target?.name || field.fieldName;
//                     const value = e.value !== undefined ? e.value : e.target?.value;
//                     onCellChange(row._id, fieldName, value);
//                 }}
//                 {...rest}
//             />
//         );
//     }
// }

// // ─── DynamicDataTable ─────────────────────────────────────────────────────────

// class DynamicDataTable extends Component {
//     constructor(props) {
//         super(props);
//         this.selfManaged = !props.rows;
//         this.state = this.selfManaged
//             ? { rows: [makeRow(props.fields || [])] }
//             : {};
//     }

//     get rows() {
//         return this.selfManaged ? this.state.rows : this.props.rows;
//     }

//     setRows = rows => {
//         if (this.selfManaged) this.setState({ rows });
//         else this.props.onRowsChange && this.props.onRowsChange(rows);
//     };

//     handleCellChange = (rowId, fieldName, value) => {
//         this.setRows(
//             this.rows.map(r => r._id === rowId ? { ...r, [fieldName]: value } : r)
//         );
//     };

//     handleAddRow    = ()    => this.setRows([...this.rows, makeRow(this.props.fields || [])]);
//     handleDeleteRow = rowId => this.setRows(this.rows.filter(r => r._id !== rowId));

//     // ── Accordion header: shows first 3 fields + delete button ──────────────
//     renderAccordionHeader(row, fields, rowIndex) {
//         const previewFields = fields.slice(0, ACCORDION_THRESHOLD);

//         return (
//             <div
//                 style={{ display: 'flex', alignItems: 'center', width: '100%', gap: '12px' }}
//                 // stop clicks on delete from toggling accordion
//             >
//                 {/* Row number */}

//                 {/* <span style={{
//                     minWidth: '22px', height: '22px',
//                     borderRadius: '50%',
//                     background: '#f0f0f0',
//                     display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
//                     fontSize: '11px', fontWeight: 700, color: '#888', flexShrink: 0,
//                 }}>
//                     {rowIndex + 1}
//                 </span> */}

//                 {/* First 3 field previews */}
//                 {previewFields.map(field => (
//                     <div key={field.fieldName} style={{ display: 'flex', flexDirection: 'column', minWidth: '100px' }}>
//                         <span style={{ fontSize: '10px', fontWeight: 700, color: '#aaa', textTransform: 'uppercase', letterSpacing: '0.4px' }}>
//                             {field.fieldDescription}
//                         </span>
//                         <span style={{ fontSize: '13px', color: '#444' }}>
//                             {row[field.fieldName] != null && row[field.fieldName] !== ''
//                                 ? String(row[field.fieldName])
//                                 : <span style={{ color: '#ccc', fontStyle: 'italic' }}>—</span>
//                             }
//                         </span>
//                     </div>
//                 ))}

//                 {/* Spacer */}
//                 <div style={{ flex: 1 }} />

//                 {/* Required incomplete indicator */}
//                 {fields.some(f => f.required && (row[f.fieldName] == null || row[f.fieldName] === '')) && (
//                     <span style={{ fontSize: '11px', color: '#c0392b', fontStyle: 'italic', flexShrink: 0 }}>
//                         incomplete
//                     </span>
//                 )}

//                 {/* Delete */}
//                 <div onClick={e => e.stopPropagation()}>
//                     <Button
//                         icon="pi pi-trash"
//                         className="p-button-danger p-button-text p-button-sm"
//                         onClick={() => this.handleDeleteRow(row._id)}
//                         tooltip="Remove row"
//                         tooltipOptions={{ position: 'top' }}
//                     />
//                 </div>
//             </div>
//         );
//     }

//     // ── Accordion body: all fields in 2-col grid ─────────────────────────────
//     renderAccordionBody(row, fields, metaData, cellPassthrough) {
//         return (
//             <div className="p-grid" style={{ margin: 0, padding: '4px 0' }}>
//                 {fields.map(field => (
//                     <div key={field.fieldName} className="p-col-12 p-md-6" style={{ padding: '6px 8px' }}>
//                         <label style={{
//                             display: 'block',
//                             fontSize: '11px', fontWeight: 700, color: '#888',
//                             textTransform: 'uppercase', letterSpacing: '0.5px', marginBottom: '4px',
//                         }}>
//                             {field.fieldDescription}
//                             {field.required && <span className="requiredColor"> *</span>}
//                         </label>
//                         <DynamicCell
//                             field={field}
//                             row={row}
//                             metaData={metaData}
//                             onCellChange={this.handleCellChange}
//                             {...cellPassthrough}
//                         />
//                     </div>
//                 ))}
//             </div>
//         );
//     }

//     render() {
//         const {
//             fields    = [],
//             metaData  = {},
//             addLabel  = 'Add New Row',
//             title,
//             rows:         _rows,
//             onRowsChange: _onRowsChange,
//             ...cellPassthrough
//         } = this.props;

//         const rows = this.rows;
//         const useAccordion = fields.length > ACCORDION_THRESHOLD;

//         return (
//             <div style={{ border: '1px solid #dee2e6', borderRadius: '4px', overflow: 'hidden' }}>

//                 {/* Title */}
//                 {title && (
//                     <div style={{ margin: 0, padding: '8px 12px', background: '#f8f9fa', borderBottom: '1px solid #dee2e6' }}>
//                         <strong style={{ fontSize: '13px', color: '#333' }}>{title}</strong>
//                     </div>
//                 )}

//                 {useAccordion ? (
//                     /* ── Accordion mode (fields > 3) ── */
//                     <>
//                         {rows.length > 0 ? (
//                             <Accordion multiple>
//                                 {rows.map((row, idx) => (
//                                     <AccordionTab
//                                         key={row._id}
//                                         header={this.renderAccordionHeader(row, fields, idx)}
//                                     >
//                                         {this.renderAccordionBody(row, fields, metaData, cellPassthrough)}
//                                     </AccordionTab>
//                                 ))}
//                             </Accordion>
//                         ) : (
//                             <div style={{ textAlign: 'center', padding: '24px', color: '#bbb', fontSize: '13px' }}>
//                                 No rows added yet.
//                             </div>
//                         )}
//                     </>
//                 ) : (
//                     /* ── Flat table mode (fields ≤ 3) ── */
//                     <>
//                         {/* Column headers */}
//                         <div className="p-grid" style={{ margin: 0, padding: '6px 0', background: '#f8f9fa', borderBottom: '1px solid #dee2e6' }}>
//                             {fields.map(field => (
//                                 <div key={field.fieldName} className="p-col">
//                                     <label style={{
//                                         fontSize: '11px', fontWeight: 700, color: '#888',
//                                         textTransform: 'uppercase', letterSpacing: '0.5px', margin: 0,
//                                     }}>
//                                         {field.fieldDescription}
//                                         {field.required && <span className="requiredColor"> *</span>}
//                                     </label>
//                                 </div>
//                             ))}
//                             <div style={{ width: '48px', flexShrink: 0 }} />
//                         </div>

//                         {/* Rows */}
//                         {rows.length > 0 ? rows.map(row => (
//                             <div key={row._id} className="p-grid align-items-center" style={{ margin: 0, borderBottom: '1px solid #f2f2f2' }}>
//                                 {fields.map(field => (
//                                     <div key={field.fieldName} className="p-col">
//                                         <DynamicCell
//                                             field={field}
//                                             row={row}
//                                             metaData={metaData}
//                                             onCellChange={this.handleCellChange}
//                                             {...cellPassthrough}
//                                         />
//                                     </div>
//                                 ))}
//                                 <div className="p-col-fixed" style={{ width: '50px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
//                                     <Button
//                                         icon="pi pi-trash"
//                                         className="p-button-danger p-button-text p-button-sm"
//                                         onClick={() => this.handleDeleteRow(row._id)}
//                                         tooltip="Remove row"
//                                         tooltipOptions={{ position: 'top' }}
//                                     />
//                                 </div>
//                             </div>
//                         )) : (
//                             <div style={{ textAlign: 'center', padding: '24px', color: '#bbb', fontSize: '13px' }}>
//                                 No rows added yet.
//                             </div>
//                         )}
//                     </>
//                 )}

//                 {/* Add row */}
//                 <div className="p-grid" style={{ margin: 0, padding: '8px 0' }}>
//                     <div className="p-col-12" style={{ textAlign: 'right' }}>
//                         <Button
//                             label={addLabel}
//                             icon="pi pi-plus"
//                             className="p-button-outlined p-button-sm"
//                             onClick={this.handleAddRow}
//                             style={{ color: '#c0392b', borderColor: '#c0392b', fontSize: '12px' }}
//                         />
//                     </div>
//                 </div>

//             </div>
//         );
//     }
// }

// export default DynamicDataTable;